import React, { useState, useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import SearchTextField from "@components/inputs/searchTextField";
import CustomButton from "@components/button/customButton";

export default function AddUserDialog({
  open,
  onClose,
  userListing = [],

  setAddedUserListing,
  loading
}) {
  const [search, setSearch] = useState("");

  const [checkedUser, setCheckedUser] = useState([])

  const handleCheckboxChange = (checked) => {
    const selectedRow = checked.map((id) => userListing.find((row) => row.userGuid === id));
    setCheckedUser(selectedRow)
  };

  const handleAddUser = () => {
    setAddedUserListing((prev) => [...prev, ...checkedUser]);

    setCheckedUser([]);
    onClose();
  }

  const handleOnClose = () => {
    setCheckedUser([]);
    onClose();
  }

  //==========================Search Function================================
  const handleFilterUserSearchVal = (user) => {
    var lowerCaseSearch = search?.toLowerCase() ?? "";
    return (
      user.fullName?.toLowerCase().includes(lowerCaseSearch)
    );
  };
  //==========================================================================

  const filterUserList = useMemo(() => {
    return userListing.filter((a) => handleFilterUserSearchVal(a))
  }, [userListing, search]);

  return (
    <Dialog 
      open={open}
      onClose={handleOnClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" fontSize={"0.9rem"} fontWeight={600} color='#202020' sx={{padding: '20px 25px'}}>
        Add User
      </DialogTitle>
      <DialogContent sx={{padding: '0px 25px', overflow: 'visible'}}>
        <SearchTextField
          sx={{ width: "50%"}}
          value={search}
          setValue={setSearch}
        />
        <DataGrid
          loading={loading}
          rows={filterUserList}
          getRowId={(row) => row.userGuid}
          columns={[
            {
              field: 'fullName',
              headerName: 'Name',
              flex: 1, minWidth: 125,
            },
            // {
            //   field: 'email',
            //   headerName: 'Email',
            //   flex: 1, minWidth: 125,
            // },
          ]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
          disableColumnResize
          disableColumnMenu
          disableColumnSelector
          disableDensitySelector
          checkboxSelection
          onRowSelectionModelChange={handleCheckboxChange}
          sx={{ border: 0 }}
        />
      </DialogContent>
      <DialogActions sx={{padding: '20px 25px'}}>
        <CustomButton color="#999999" onClick={()=>handleOnClose()}>
          Cancel
        </CustomButton>
        <CustomButton disabled={checkedUser.length === 0} onClick={handleAddUser}>
          Add
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}